import { MediaPlusText } from '@design-system/media-plus-text';
import { PageBlock } from '@design-system/page-block';
import React, { forwardRef } from 'react';

import { MediaPlusTextBlockProps } from './models';

const MediaPlusTextBlock = forwardRef<HTMLDivElement, MediaPlusTextBlockProps>(
  (
    { pageBlock: { heading, ...pageBlockProps }, componentId, uid, ...rest },
    ref
  ) => (
    <PageBlock
      {...pageBlockProps}
      className="media-plus-text-block"
      componentUid={uid}
      id={componentId}
      ref={ref}
    >
      <MediaPlusText {...{ ...rest, heading }} />
    </PageBlock>
  )
);

export default MediaPlusTextBlock;
